"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var API_1 = require("../../API");
var PaymentFilter = /** @class */ (function () {
    function PaymentFilter(companyId, limit, offset) {
        var _this = this;
        this.productIds = [];
        this.customerSearchQuery = '';
        this.searchedCustomers = [];
        this.startDate = null;
        this.endDate = null;
        this.companyId = companyId;
        this.limit = limit;
        this.offset = offset;
        mobx_1.observe(this, function (change) {
            if (change.name !== 'offset') {
                _this.offset = 0;
            }
        });
    }
    PaymentFilter.prototype.setLocationIds = function (locationIds) {
        this.locationIds = locationIds;
    };
    PaymentFilter.prototype.setProductIds = function (productIds) {
        this.productIds = productIds;
    };
    PaymentFilter.prototype.setDiscountId = function (discountId) {
        this.discountId = discountId;
    };
    PaymentFilter.prototype.setCustomerId = function (customerId) {
        this.customerId = customerId;
    };
    PaymentFilter.prototype.setEmployeeId = function (employeeId) {
        this.employeeId = employeeId;
    };
    PaymentFilter.prototype.setPaymentType = function (paymentType) {
        this.paymentType = paymentType;
    };
    PaymentFilter.prototype.setLimit = function (limit) {
        this.limit = limit;
    };
    PaymentFilter.prototype.setOffset = function (offset) {
        this.offset = offset;
    };
    PaymentFilter.prototype.setSearchedCustomers = function (customers) {
        this.searchedCustomers = customers;
    };
    PaymentFilter.prototype.setCustomerSearchQuery = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var customers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.customerSearchQuery = query;
                        if (!(query && query.length > 2)) return [3 /*break*/, 2];
                        return [4 /*yield*/, API_1.API.searchCustomers(this.companyId, query)];
                    case 1:
                        customers = (_a.sent()).customers;
                        this.setSearchedCustomers(customers);
                        return [3 /*break*/, 3];
                    case 2:
                        this.searchedCustomers = [];
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.searchedCustomers];
                }
            });
        });
    };
    PaymentFilter.prototype.setCustomer = function (customer) {
        this.selectedCustomer = customer;
        this.searchedCustomers = [];
        this.customerSearchQuery = '';
    };
    PaymentFilter.prototype.setDeviceId = function (deviceId) {
        this.deviceId = deviceId;
    };
    PaymentFilter.prototype.setStartDate = function (startDate) {
        this.startDate = startDate;
    };
    PaymentFilter.prototype.setEndDate = function (endDate) {
        this.endDate = endDate;
    };
    PaymentFilter.prototype.setShiftId = function (shiftId) {
        this.shiftId = shiftId;
    };
    PaymentFilter.prototype.setStatus = function (status) {
        if (status) {
            this.status = status;
        }
        else {
            this.status = undefined;
        }
    };
    PaymentFilter.prototype.setCustomId = function (customId) {
        this.customId = customId;
    };
    PaymentFilter.prototype.setExternalSourceId = function (externalSourceId) {
        this.externalSourceId = externalSourceId;
    };
    PaymentFilter.prototype.setShowOnlineDiscrepancies = function (showOnlineDiscrepancies) {
        this.showOnlineDiscrepancies = showOnlineDiscrepancies;
    };
    PaymentFilter.prototype.getQueryString = function () {
        var queryString = '';
        if (this.locationIds && this.locationIds.length > 0) {
            queryString += "&locationIds=" + JSON.stringify(this.locationIds);
        }
        if (this.shiftId) {
            queryString += "&shiftId=" + this.shiftId;
        }
        if (this.productIds.length > 0) {
            queryString += "&productIds=" + JSON.stringify(this.productIds);
        }
        if (this.discountId !== undefined) {
            queryString += "&discountId=" + this.discountId;
        }
        if (this.paymentType) {
            queryString += "&paymentType=" + this.paymentType;
        }
        if (this.limit) {
            queryString += "&limit=" + this.limit;
        }
        if (this.offset) {
            queryString += "&offset=" + this.offset;
        }
        if (this.employeeId) {
            queryString += "&employeeId=" + this.employeeId;
        }
        if (this.customerId) {
            queryString += "&customerId=" + this.customerId;
        }
        if (this.selectedCustomer) {
            queryString += "&customerId=" + this.selectedCustomer.id;
        }
        if (this.deviceId) {
            queryString += "&deviceId=" + this.deviceId;
        }
        if (this.status) {
            queryString += "&status=" + this.status;
        }
        if (this.startDate && this.endDate) {
            queryString += "&startDate=" + this.startDate.startOf('day').toDate().toISOString();
            queryString += "&endDate=" + this.endDate.endOf('day').toDate().toISOString();
        }
        if (this.customId) {
            queryString += "&customId=" + this.customId;
        }
        if (this.externalSourceId !== undefined) {
            queryString += "&externalSourceId=" + this.externalSourceId;
        }
        if (this.showOnlineDiscrepancies !== undefined) {
            queryString += "&showOnlineDiscrepancies=" + this.showOnlineDiscrepancies;
        }
        return queryString;
    };
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "companyId", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "locationIds", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setLocationIds", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "productIds", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setProductIds", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "discountId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setDiscountId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "customerId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setCustomerId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "employeeId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setEmployeeId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "paymentType", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setPaymentType", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "limit", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setLimit", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "offset", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setOffset", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "customerSearchQuery", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "searchedCustomers", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setSearchedCustomers", null);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setCustomerSearchQuery", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "selectedCustomer", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setCustomer", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "deviceId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setDeviceId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "startDate", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setStartDate", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "endDate", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setEndDate", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "shiftId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setShiftId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "status", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setStatus", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "customId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setCustomId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "externalSourceId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setExternalSourceId", null);
    __decorate([
        mobx_1.observable
    ], PaymentFilter.prototype, "showOnlineDiscrepancies", void 0);
    __decorate([
        mobx_1.action
    ], PaymentFilter.prototype, "setShowOnlineDiscrepancies", null);
    return PaymentFilter;
}());
exports.PaymentFilter = PaymentFilter;
//# sourceMappingURL=PaymentFilter.js.map